@if (syndicate) {
  <div class="syndi-join-card x-sell">
    <div class="syndi-join-top-row">
      <div class="captain-information">
        <img [alt]="syndicate.manager?.username" class="captain-image" imgLazyLoad [src]="syndicate.manager.picture_url" (error)="setFallbackImage()" />
        <div class="w-full">
          <div class="join-card-creator">
            {{syndicate.manager?.username}}
          </div>
          <div class="join-card-prize">
            @if (syndicate.pool.type_code === 'RACE_PLACE') {
              <span class="playing_for_prize">
                <span class="mr-1.5" [transloco]="'poolHeader.POOL_TOTAL'"></span>
                <strong class="cb-bold highlight">{{ calculatePrize(syndicate.pool.headline_prize, true) | currencyAmount:syndicate.pool.currency:0}}</strong>
              </span>
            } @else {
              <span class="playing_for_prize">
              <span class="mr-1.5" [transloco]="'ticketSyndicate.PLAYING_FOR'"></span>
              <strong class="cb-bold highlight">{{ calculatePrize(syndicate.pool.headline_prize) | currencyAmount:syndicate.pool.currency:0}}</strong>
            </span>
            }
          </div>
        </div>
      </div>
      @if ((syndicate.amount_funded !== '1.0' && syndicate.amount_funded !== '0.0') || showPercentage) {
        <div>
          <div class="funded-percentage">
            <span class="highlight">{{ (syndicate.amount_funded * 100) | localeNumberFormat:1:true }}%</span>
            <span [transloco]="'ticketSyndicate.FUNDED'"></span>
          </div>
        </div>
      }
    </div>
    <div class="join-card-bottom-row">
      <div class="join-card-cost">
        <span class="mr-1.5" [transloco]="'syndicateBetslip.TOTAL_VALUE'"></span>
        <span>{{ syndicate.cost | currencyAmount:syndicate.pool.currency:2 }}</span>
      </div>
      <div class="contributors-div">
        <i class="fas fa-user-friends mr-1.5"></i>
        <span>{{syndicate.total_portions}}</span>
      </div>
    </div>
  </div>
}